module.exports = __webpack_public_path__ + "img/Login_active.f415051e.svg";